import { Link } from 'react-router-dom';
import { DSFA_LABEL, DSFA_VARIANT, useDsfa } from '../lib/dsfa';
import { Badge } from './ui';

/**
 * Datenschutz-Status an einer Einstellung.
 *
 * Zeigt die Farbe, die der DSFA-Report (Audit → DSFA-Report) für diese
 * Einstellung vergibt, und führt dorthin. Ohne Recht auf den Report oder bei
 * unbekanntem Schlüssel erscheint nichts.
 */
export function DsfaBadge({ id }: { id: string }) {
  const { report } = useDsfa();
  const item = report?.items.find((entry) => entry.key === id);
  if (!item) return null;
  return (
    <Link to="/admin/dsfa" title={`${item.reason}\n\n${item.why}`} style={{ textDecoration: 'none' }}>
      <Badge variant={DSFA_VARIANT[item.status]} dot>
        DSFA {DSFA_LABEL[item.status]}
      </Badge>
    </Link>
  );
}
